import BASEURLGESTTOR from '../api/gesttor'

export function clientesTotais () {
    return BASEURLGESTTOR.get('/dashboard/clientestotais')
}

export function clientesMes () {
    return BASEURLGESTTOR.get('/dashboard/clientesnovos')
}

export function clientesAtivos () {
    return BASEURLGESTTOR.get('/dashboard/clientesativos')
}

export function clientesInativos () {
    return BASEURLGESTTOR.get('/dashboard/clientesinativos')
}

export function clientesCidades () {
    return BASEURLGESTTOR.get('/dashboard/grafico/clientescidade')
}

export function clientesAtivosMes () {
    return BASEURLGESTTOR.get('/dashboard/grafico/clientesmes')
}

export function leadFormaConhecimento () {
    return BASEURLGESTTOR.get('/dashboard/grafico/leads')
}

export function npsOrganizacao () {
    return BASEURLGESTTOR.get ('/nps/organizacao')
}